<template>
  <CCard class="pointer navigation_card" @click="openSidebarRight('flow_details', { sw_group_id_external: flowData.sw_group_id_external })">
    <CCardBody>
      <div class="d-flex align-items-center">
        <div v-if="flowData.image_id"
            class="item_image mr-2"            
            v-bind:style="{ backgroundImage: 'url(' + apiBaseUrl + '/v1/common/cdn/file/image/connect-flow/' + flowData.sw_group_id_external + '/' + flowData.image_id + '.jpg' + '/' + clientToken}">
        </div>
        <div v-else class="item_icon d-inline-block align-middle mr-2">
          <i class="fas fa-stream"/>               
        </div>                     
        <div class="flex-grow-1">        
          <span><b>{{flowData.sw_group_name}}</b></span>
          <div class="meta">
            <span>{{flowData.nr_of_posts}} {{flowData.nr_of_posts !== 1 ? $t('common.posts') : $t('common.post')}}</span>
          </div>          
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>

export default {
  name: 'connectFlowCard',
  props: ['flow'],
  watch: {
    $props: {
      handler() {
        if(this.flow) this.flowData = this.flow;
      },
      deep: true,
      immediate: true,
    }
  },
  data() {
    return {
      apiBaseUrl: null,
      clientToken: null,      
      flowData: {}
    }
  },
  mounted: function() {
    this.apiBaseUrl = process.env.VUE_APP_API_URL;
    this.clientToken = localStorage.getItem('token');
  }   
}
</script>
